module.exports = __webpack_public_path__ + "static/media/partitionBottomImg1.968e0305.png";